import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getOrderedPartTypeList = createAsyncThunk(
  'general/getOrderedPartTypeList',
  async (type, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/general/list/orderedTypes');
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => !getState().getOrderedPartsList.loading
  }
);

export default getOrderedPartTypeList;
